const educationData = [
  {
    date: "2023-2025",
    title: "Masters in Computer Application",
    content: "G.H.Raisoni College Amravati University, Nagpur ",
    marks: "9.33 CGPA ",
  },
  {
    date: "2020-2023",
    title: "Bachelors of Science(B.Sc)-PCM",
    content: "Shri. Shivaji Science College, Nagpur University (RTMNU)",
    marks: "80.22%",
  },
  {
    date: "2019-2020",
    title: "Senior Secondary (12th Science)",
    content: "Maharashtra State Board",
    marks: "88.15%",
  },
  {
    date: "2017-2018",
    title: "Secondary (Class 10th)",
    content: "Maharashtra State Board",
    marks: "94.00%",
  },
];

export default educationData;
